import { Mark15 } from './mark-15';

/**
 * PROOF OF VISIT — the peak moment.
 *
 * The brand board's honest diagnosis was that nothing on the site was memorable:
 * "there is no peak moment. Nothing on any page is the thing you remember. The
 * proof-of-visit card was designed in words and never built, and the hero has an
 * empty right side sized for exactly that." This is that card, built.
 *
 * It is shown FILLED, not as a blank template. The whole positioning is "you won't
 * have to wonder" — a blank form asks the buyer to imagine the proof; a completed
 * record shows it. They are looking at the artefact they will actually receive.
 *
 * Every value is a deliberate placeholder using the reserved fictional ranges. No
 * real client, building, address or crew member appears here — this is a marketing
 * page, and a real record on it would publish a customer's premises to the world.
 */
export function ProofOfVisit({ className }: { className?: string }) {
  return (
    <figure className={['proof-card', className].filter(Boolean).join(' ')}>
      <div className="proof-card-lamp" aria-hidden="true" />

      <div className="proof-card-head">
        <div>
          <p className="proof-card-title">Proof of visit</p>
          <p className="proof-card-org">Second Shift Cleaning</p>
        </div>
        {/* The primary mark, compact. Was the slat mark, which the 2026-09-05 board
            retired — a card that exists to prove WHO was in the building should not
            be signed with a logo the company no longer uses. */}
        <span className="proof-card-mark" aria-hidden="true">
          <Mark15 height={30} detail="compact" />
        </span>
      </div>

      <dl className="proof-card-body">
        <div className="proof-row">
          <dt>Location</dt>
          <dd>Suite 210 · 123 Main St</dd>
        </div>

        <div className="proof-row proof-row-split">
          <div>
            <dt>Shift completed</dt>
            <dd>Tue 4 Mar</dd>
          </div>
          <div>
            <dt className="sr-only">Time</dt>
            <dd>6:15 – 8:40 pm</dd>
          </div>
        </div>

        <div className="proof-row">
          <dt>Crew</dt>
          <dd>Alex R. · Jordan E.</dd>
        </div>

        <div className="proof-row">
          <dt>Notes</dt>
          <dd>Soap dispenser in the west restroom is empty — refilled, replacement ordered.</dd>
        </div>
      </dl>

      <figcaption className="proof-card-foot">
        <span className="proof-card-stamp">Sent 8:41 pm</span>
        <span>You get one of these every visit. You never have to ask.</span>
      </figcaption>
    </figure>
  );
}
